<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 text-left mb-3">Order Changes Needed</h3>

            <p class="explanation-text mb-3">
                If {{ nickname }} had clicked "Request Changes", indicating the need to modify the order details,
                here's what would happen:
            </p>

            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanation_points"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="16"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text">{{ point }}</p>
                </div>
            </div>
        </div>

        <div class="primary-note">
            <v-icon
                color="info"
                size="20"
                aria-hidden="true"
                left
            >
                mdi-information
            </v-icon>
            <div>
                <p class="text-body-2 mb-0">
                    <strong class="d-inline-block mb-1">Integration Point</strong>
                </p>
                <span class="text-body-2">
                    When Sarah submits this form, it will be sent to the existing Web Chat system for your support team
                    in RedChirp
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        nickname() {
            return this.order_data?.customer_nickname || 'The customer';
        },

        explanation_points() {
            return [
                `She is directed to this form, which provides a "What needs changed?" field, allowing her to explain what needs to be modified`,
                `She clicks "Agree and Send". In doing so, she provides written consent by virtue of the disclaimer presented to her above the button`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }
}
</style>
